import { useEffect, useState } from 'react';
/** Small scrolls (rubber-band bounces, trackpad jitter) must not toggle the area. */
const SCROLL_DELTA_THRESHOLD = 8;
/**
 * Tells whether the element behind `elementRef` should be hidden while the user scrolls the page down.
 * Scrolling up, or staying near the top of the page, shows it again.
 *
 * The element stays visible until the page is scrolled past the element's own height: the element is
 * hidden by a transform only, so hiding it earlier would uncover the empty space it still occupies.
 */
export const useHideOnScrollDown = (elementRef, isEnabled) => {
    const [isHidden, setIsHidden] = useState(false);
    useEffect(() => {
        // Most pages pass no collapsible content, and they must not pay for a scroll listener.
        if (!isEnabled)
            return;
        let lastScrollY = window.scrollY;
        const handleScroll = () => {
            const { scrollY } = window;
            const delta = scrollY - lastScrollY;
            if (Math.abs(delta) < SCROLL_DELTA_THRESHOLD)
                return;
            lastScrollY = scrollY;
            setIsHidden(delta > 0 && scrollY > (elementRef.current?.offsetHeight ?? 0));
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [elementRef, isEnabled]);
    return isHidden;
};
